<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table ix-table-sm">
                        <thead>
                        <tr>
                            <th>Numéro de facture</th>
                            <th>Client</th>
                            <th>Montant à régler</th>
                            <th class="text-right">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(bill, index) in bills" v-if="!loading">
                            <td>
                                {{ bill.full_designation }}
                                <input type="hidden" :name="'bills[' + index + '][id]'" v-model="bill.id" required>
                                <input type="hidden" :name="'bills[' + index + '][full_designation]'" v-model="bill.full_designation" required>
                                <input type="hidden" :name="'bills[' + index + '][company][name]'" v-model="bill.company.name" required>
                            </td>
                            <td>
                                {{ bill.company.name }}
                            </td>
                            <td>
                                <div class="input-group input-group-sm">
                                    <input type="number" class="form-control text-right" :name="'bills[' + index + '][total]'" v-model="bill.total" required step="0.01">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr class="ix-table-row-dark" v-if="!loading">
                            <td class="ix-text-bold" colspan="2">Total</td>
                            <td class="text-right">
                                <span class="ix-text-large ix-text-bold">{{ currency(total) }}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="4" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="4">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="billSearchInput" type="text" v-model="bill">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'bill-payment-order-selector',
        props: ['route', 'oldBills'],
        data() {
            return {
                loading: true,
                bill: null,
                bills: [],
            };
        },
        computed: {
            total: function() {
                var sum = 0;
                this.bills.forEach(bill => sum += parseFloat(bill.total));
                return sum;
            }
        },
        methods : {
            addRow: function (bill) {
                if (this.getCurrentSelectedBillsId().includes(bill.id) == false) {
                    this.bills.push({
                        id: bill.id,
                        full_designation: bill.full_designation,
                        company: {
                            name: bill.company.name
                        },
                        total: bill.total ? bill.total : (bill.pivot ? bill.pivot.total : bill.total_remaining)
                    })
                }
            },
            deleteRow: function (index) {
                this.bills.splice(index, 1)
                if (this.bills.length == 0) {
                    this.addRow()
                }
            },
            getCurrentSelectedBillsId: function() {
                return this.bills.map(bill => bill.id);
            }
        },
        mounted(){
            $("#billSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedBillsId().join(';'), 'hasremaining': true, 'valid': 'only' },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.full_designation,
                                    value: item.full_designation,
                                    formatted_total_remaining: this.currency(item.total_remaining)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = (ul, item) => {
                        var html = `<div class="d-flex align-items-center justify-content-between">
                                      <span>${item.full_designation} (${item.company.name})</span>
                                      <span>Restant dû : ${item.formatted_total_remaining}</span>
                                    </div>`;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.bill = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRow(item.item)

                        $(e.target).val("")
                        this.bill = null
                    }
                }
            }).focus(() => {
                $("#billSearchInput").autocomplete("search", '');
            });

            const jsonBillBackup = JSON.parse(this.oldBills)
            if (Array.isArray(jsonBillBackup)) {
                if (jsonBillBackup.length > 0) {
                    jsonBillBackup.forEach(bill => {
                        this.addRow(bill)
                    })
                }
            }
            this.loading = false
        }
    }
</script>
